import {inject} from '@angular/core';
import {ResolveFn} from '@angular/router';
import {Store} from '@ngrx/store';
import {loadScreeningSettings} from '../screening-settings/screening-settings.actions';
import {loadScreeningCriterias} from '../screening-criteria/screening-criteria.actions';
import {loadResearchKeywords} from '../research-keyword/research-keyword.actions';


export const screeningSettingsResolver: ResolveFn<boolean> = (route, state) => {
  const store = inject(Store);
  const projectIdString = route.parent!.paramMap.get('projectId');
  if (!projectIdString) {
    return false;
  }
  const projectId = +projectIdString;
  store.dispatch(loadScreeningSettings({projectId}));
  store.dispatch(loadScreeningCriterias({projectId: projectId}));
  store.dispatch(loadResearchKeywords({projectId: projectId}));
  return true;
};

